"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketCorsOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketCorsOutput.js.map